import api from '@/api_alv'
import Vue from 'vue'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'

const DIR = 'contracts/publishing'
const DEFAULT_CONTRACT = {
    "id"                    : 0,
    "alvId"                 : "ALV000000000CP",
    "licensor"              : null,
    "title"                 : null,
    "contractName"          : null,
    "numberOfAssignedWorks" : 0,
    "contractDate"          : null,
    "contractType"          : null,
    "notes"                 : null,
    "territories"          : { "include": [], "exclude": [] },
    "gemaAgreementNo"       : null,
    "gemaScheduleNo"        : null,
    "initialBalance"        : null,
    "initialBalancePeriod"  : { "num": null, "period": null, "year": null},
    "tags"                  : null,
    "validFrom"             : null,
    "validUntil"            : null,
    "gemaContractType"      : null,
    "reminderDate"          : null,
    "refunding"             : "pwr",
    "spTresholdPr"          : null,
    "spTresholdMr"          : null,
    "arColl"                : null,
    "mrColl"                : null,
    "mrCollShareFrom"       : null,
    "svdForSpw"             : "no",
    "sourceAdaption"        : "",
    "works"                 : [],
    "splits"                : [],
    "conditions"            : [],
    "advance"               : [],
    "agreementNumbers"      : [],
}

function publishingTerritoryCodes(list) {
    if (!Array.isArray(list)) return []
    return list.map((entry) => {
        if (entry && typeof entry === 'object') return entry.value || ''
        return entry
    }).filter(Boolean)
}

function territoryOptionList(selected, options) {
    const list = Array.isArray(options)
        ? options.filter((item) => item && typeof item === 'object' && item.value)
        : []
    const seen = {}
    list.forEach((item) => { seen[item.value] = true })
    const merged = list.slice()
    publishingTerritoryCodes(selected).forEach((code) => {
        if (!seen[code]) {
            seen[code] = true
            merged.unshift({ text: code, value: code })
        }
    })
    return merged
}

function ensurePublishingContractTerritories(details) {
    if (!details) return { include: [], exclude: [] }
    if (!details.territories || typeof details.territories !== 'object' || Array.isArray(details.territories)) {
        Vue.set(details, 'territories', { include: [], exclude: [] })
    }
    if (!Array.isArray(details.territories.include)) Vue.set(details.territories, 'include', [])
    if (!Array.isArray(details.territories.exclude)) Vue.set(details.territories, 'exclude', [])
    return details.territories
}

const DEFAULT_AGREEMENT_NUMBER = {
    "id": 0,
    "subcatalogId": "", // empty = nothing chosen yet, null = main catalogue

    "sourceAlvId": null,
    "agreementNumber": null,
}

const DEFAULT_ADVANCE = {
    "id": 0,
    "description": null,
    "enteredBy": null,
    "enteredOn": null,
    "entered": "manual",
    "amount": null,
    "balance": null,
}

const DEFAULT_SPLITS = {
    "id"        : 0,
    "rights"    : null,
    "split"     : null,
    "base"      : null,
    "region"    : {
        "exclude": [],
        "include": []
    },
    "applyTo"   : null
}

const DEFAULT_SUB_CATALOGUE = {
    "id"                : 0,
    "gemaAgreementNo"   : null,
    "gemaScheduleNo"    : null,
    "licensor"          : null,
    "notes"             : null,
    "validUntil"        : null,
    "processableUntil"  : null,
    "alvId"             : "ALV000000000CS"
}

const DEFAULT_COSTS = {
    "id": 0,
    "costGroup": null,
    "date": null,
    "recipient": null,
    "description": null,
    "amount": null,
    "documentNumber": null,
    "country": null,
    "paidOn": null,
    "accountingPeriod": { "num": null, "period": null, "year": null },
    "split": null,
    "assignToWork": null,
}

const DEFAULT_CONDITION = {
    "id"        : 0,
    'sourceId': null,
    'recipientId': null,
    'svavPublisherQuota': null,
    'svavShareType': null,
    "splits"   : []
}

const DEFAULT_CONDITION_SPLIT = {
    "id": 0,
    'rightsType': 'all',
    'category': null,
    'recipientId': null,
    'subCategory': null,
    'split': null,
    'weighting': null,
    'weightingSource': null,
    'sharesToConsider': null,
    'applyTo': "incomingMoney",
    'order': null,
    'base': null,
}

const state = {
    // Edit conditions
    showEditSplitDialog: false,
    showConditionDialog: false,
    
    // Edit conditions splits dialog
    selectedEditPublishingContractSplits: null,
    selectedEditPublishingContractConditions: null,
    editSplitsDetailsWeighting: '',
    editSplitsDetailsRights: '',
    editSplitsDetailsCategory: '',
    editSplitsDetailsSubcategory: '',
    editSplitsDetailsSplit: '',
    editSplitsDetailsApplyTo: '',
    editSplitsDetailsBase: '',

// List
    publishingContracts: [],
    publishingReminders: {},
    selectedPublishingContracts : [],
    isAllSelectedPublishingContracts: false,
    expandedPublishingContracts: [],
    publishingContractsServerSideSortingOptions: {
        sortBy: ['contractName'],
        sortDesc: [false],
        mustSort: true
    },

// Filters
    publishingContractsSearch: "" ,
    selectedPublishingContractsQualityFilter: [],

// Actions
    selectedPublishingContractsAction: [],
// Actions:Move
    publishingContractsDetailsSelectedCompany:[],
// Actions:copyConditions
    copyConditionsForPublishingContractsSearch: "",
    selectedCopyConditionsForPublishingContracts: [],
    copyConditionsForPublishingContractsCsvPath: null,
    copyConditionsForPublishingContractsTags: "",
    copyConditionsForPublishingContractsAdaptRecipient: false,

// Actions:export
    showContractsPublishingExportDialog: false,
    contractsPublishingExportAll: false,
    contractsPublishingExportType: "mappings",
    contractsPublishingExportMappingId: null,

// Details
    defaultNewPublishingContract: DEFAULT_CONTRACT, 
    publishingContractUniqueId: '',     
    publishingContractsDetails: {},
    publishingContractsLicensorOptions: [],
    publishingContractsIncludeOptions: [],
    publishingContractsExcludeOptions: [],

    // WORKS PANEL
    publishingContractsWorks: [],
    selectedContractPublishingWork: [],
    selectedWorksForContract: [],
    worksForContractSearch: "",
    totalWorksForContractListed: "",
    totalWorksForContractRecords: "",
    publishingContractsWorksSearch: '',
    showWorksDeleteResultListButton: false,
    showSetWorksTypeDialog: false,
    worksSearchId: null,

    // SPLITS PANEL
    publishingContractSplits: [],
    selectedPublishingContractSplits: [],
    defaultPublishingContractSplits: DEFAULT_SPLITS,
    publishingContractSplitsEditingDialogDetails: DEFAULT_SPLITS,
    publishingContractTypeOfRights: [],
    // MEDIA PANEL
    selectedPublishingContractsMediaFiles: [],
    // Regions
    publishingContractSplitsEditingDialogIncludeOptions: [],
    publishingContractSplitsEditingDialogExcludeOptions: [],
    publishingContractSplitsEditingDialogDetailsInclude: [],
    publishingContractSplitsEditingDialogDetailsExclude: [],

    // Conditions
    publishingContractConditionsEditingDialogDetails: DEFAULT_CONDITION,
    defaultPublishingContractConditions: DEFAULT_CONDITION,
    activeConditionId: null,
    publishingContractConditionsRecipientIdOptions: null,
    publishingContractConditions: [],
    selectedPublishingContractConditions: [],
    publishingContractDetailsRecipientId: null,
    showPublishingContractConditionsEditingDialog: false,

    // Conditions Splits
    publishingContractDetailsSplitsRecipientId: null,
    publishingContractConditionsSplitsDetailsRecipientId: null,
    publishingContractConditionsSplitsEditingDialogDetails: DEFAULT_CONDITION_SPLIT,
    publishingContractConditionsSplitsRecipientIdOptions: null,
    publishingContractConditionsSplitsSharesToConsiderOptions: null,
    // Cache for A-Z persons to avoid repeated API calls
    azPersonsCache: {},
    defaultPublishingContractConditionsSplits: DEFAULT_CONDITION_SPLIT,
    publishingContractConditionsSplits: [],
    selectedPublishingContractConditionsSplits: [],
    showPublishingContractConditionsSplitsEditingDialog: false,


    publishingContractConditionsSplitsDetailsRightsType: null,
    publishingContractConditionsSplitsDetailsCategory: null,
    publishingContractConditionsSplitsDetailsSubCategory: null,
    publishingContractConditionsSplitsDetailsSplit: null,
    publishingContractConditionsSplitsDetailsWeighting: null,
    publishingContractConditionsSplitsDetailsWeightingSource: null,
    publishingContractConditionsSplitsDetailsSharesToConsider: null,
    publishingContractConditionsSplitsDetailsApplyTo: null,
    publishingContractConditionsSplitsDetailsOrder: null,
    publishingContractConditionsSplitsDetailsBase: null,
    publishingContractConditionsSplitsIncludeOptions: [],
    publishingContractConditionsSplitsExcludeOptions: [],
    publishingContractConditionsSplitsDetailsInclude: [],
    publishingContractConditionsSplitsDetailsExclude: [],

    // GROUPED CONTRACTS Panel
    publishingContractsGroupedContracts: [],
    showPublishingContractsGroupDialog: false,
    publishingContractsGroupDialogName: '',

    // AGREEMENT NUMBERS PANEL
    publishingContractsAgreementNumbers: [],
    selectedPublishingContractsAgreementNumbers: [],
    defaultPublishingContractsAgreementNumbers: DEFAULT_AGREEMENT_NUMBER,
    showPublishingContractsAgreementNumbersEditingDialog: false,
    publishingContractsAgreementNumbersEditingDialogDetails: DEFAULT_AGREEMENT_NUMBER,

    // ADVANCE PANEL
    publishingContractsAdvance: [],
    selectedPublishingContractsAdvance: [],
    defaultPublishingContractsAdvance: DEFAULT_ADVANCE,
    showPublishingContractsAdvanceEditingDialog: false,
    publishingContractsAdvanceEditingDialogDetails: DEFAULT_ADVANCE,

    // COSTS PANEL
    publishingContractsCosts: [],
    selectedPublishingContractsCosts: [],
    defaultPublishingContractsCosts: DEFAULT_COSTS,
    showPublishingContractsCostsEditingDialog: false,
    publishingContractsCostsEditingDialogDetails: DEFAULT_COSTS,
    publishingContractsCostsRecipientOptions: [],
    publishingContractsCostsAssignToWorkOptions: [],
    publishingContractsCostsTotalRecords: 0,
    publishingContractsCostsTotalListed: 0,
    publishingContractsCostsCurrentPage: 1,
    publishingContractsCostsNumberOfPages: 0,

    // SUB-CATALOGUES PANEL
    publishingContractsSubCatalogues: [],
    selectedPublishingContractsSubCatalogues: [],
    publishingContractsSubCataloguesWorksSearch: '',
    showSubCataloguesWorksDeleteResultListButton: false,
    subCataloguesWorksSearchId: null,
    // Edit sub-catalogues
    defaultPublishingContractsSubCatalogues: DEFAULT_SUB_CATALOGUE,
    publishingContractsSubCataloguesEditingDialogDetails: DEFAULT_SUB_CATALOGUE,
    publishingContractsSubCataloguesLicensorOptions: [],
    // Edit works sub-catalogues
    publishingContractsSubCataloguesWorks: [],
    showSearchSubCataloguesWorksDialog: false,
    worksForSubCataloguesSearch: "",
    selectedWorksForSubCatalogues: [],
    //MEDIA Panel
    publishingContractsMedia: [],
    publishingContractsMediaCheckbox:[],
}

const getters = {
    // Edit conditions
    getShowEditSplitDialog(state) { return state.showEditSplitDialog },
    getShowConditionDialog(state) { return state.showConditionDialog },

    // Edit conditions splits dialog
    getSelectedEditPublishingContractSplits(state) { return state.selectedEditPublishingContractSplits },
    getSelectedEditPublishingContractConditions(state) { return state.selectedEditPublishingContractConditions },
    getEditSplitsDetailsWeighting(state) { return state.editSplitsDetailsWeighting },
    getEditSplitsDetailsRights(state) { return state.editSplitsDetailsRights },
    getEditSplitsDetailsCategory(state) { return state.editSplitsDetailsCategory },
    getEditSplitsDetailsSubcategory(state) { return state.editSplitsDetailsSubcategory },
    getEditSplitsDetailsSplit(state) { return state.editSplitsDetailsSplit },
    getEditSplitsDetailsApplyTo(state) { return state.editSplitsDetailsApplyTo },
    getEditSplitsDetailsBase(state) { return state.editSplitsDetailsBase },

// List
    getPublishingContracts(state) { return state.publishingContracts },
    getPublishingReminders(state) { return state.publishingReminders },
    getSelectedPublishingContracts(state) { return state.selectedPublishingContracts },
    getIsAllSelectedPublishingContracts(state) { return state.isAllSelectedPublishingContracts },
    getExpandedPublishingContracts(state) { return state.expandedPublishingContracts },
    getPublishingContractsServerSideSortingOptions(state) { return state.publishingContractsServerSideSortingOptions },

// Filters
    getPublishingContractsSearch(state)                     { return state.publishingContractsSearch },
    getSelectedPublishingContractsQualityFilter(state)      { return state.selectedPublishingContractsQualityFilter },

// Actions
    getSelectedPublishingContractsAction                    (state) { return state.selectedPublishingContractsAction },
    getPublishingContractsDetailsSelectedCompany            (state) { return state.publishingContractsDetailsSelectedCompany },
    getCopyConditionsForPublishingContractsSearch           (state) { return state.copyConditionsForPublishingContractsSearch },
    getSelectedCopyConditionsForPublishingContracts         (state) { return state.selectedCopyConditionsForPublishingContracts },
    getCopyConditionsForPublishingContractsCsvPath          (state) { return state.copyConditionsForPublishingContractsCsvPath },
    getCopyConditionsForPublishingContractsTags             (state) { return state.copyConditionsForPublishingContractsTags },
    getCopyConditionsForPublishingContractsAdaptRecipient   (state) { return state.copyConditionsForPublishingContractsAdaptRecipient },
    getShowContractsPublishingExportDialog                  (state) { return state.showContractsPublishingExportDialog },
    getContractsPublishingExportDetailsType                 (state) { return state.contractsPublishingExportType },
    getContractsPublishingExportDetailsMappingId            (state) { return state.contractsPublishingExportMappingId },
    getContractsPublishingExportAll                         (state) { return state.contractsPublishingExportAll },
// Details
    getDefaultNewPublishingContract(state) { return state.defaultNewPublishingContract },    
    getPublishingContractsUniqueId(state) { return state.publishingContractUniqueId },
    getPublishingContractsDetails(state) { return state.publishingContractsDetails },
    getPublishingContractsLicensorOptions(state) { return state.publishingContractsLicensorOptions },

    // Edit Form Fields
    getPublishingContractsDetailsContractName               (state) { return state.publishingContractsDetails.contractName },
    getPublishingContractsDetailsContractType               (state) { return state.publishingContractsDetails.contractType },
    getPublishingContractsDetailsLicensor                   (state) { return state.publishingContractsDetails.licensor },
    getPublishingContractsDetailsNotes                      (state) { return state.publishingContractsDetails.notes },
    getPublishingContractsDetailsInclude(state) {
        const territories = ensurePublishingContractTerritories(state.publishingContractsDetails)
        return territories.include
    },
    getPublishingContractsDetailsExclude(state) {
        const territories = ensurePublishingContractTerritories(state.publishingContractsDetails)
        return territories.exclude
    },
    getPublishingContractsIncludeOptions(state) {
        const territories = state.publishingContractsDetails.territories
        return territoryOptionList(territories && territories.include, state.publishingContractsIncludeOptions)
    },
    getPublishingContractsExcludeOptions(state) {
        const territories = state.publishingContractsDetails.territories
        return territoryOptionList(territories && territories.exclude, state.publishingContractsExcludeOptions)
    },
    getPublishingContractsDetailsAlvId                      (state) { return state.publishingContractsDetails.alvId },
    getPublishingContractsDetailsGemaAgreementNo            (state) { return state.publishingContractsDetails.gemaAgreementNo },
    getPublishingContractsDetailsGemaScheduleNo             (state) { return state.publishingContractsDetails.gemaScheduleNo },
    getPublishingContractsDetailsInitialBalance             (state) { return state.publishingContractsDetails.initialBalance },
    getPublishingContractsDetailsInitialBalancePeriod       (state) { return state.publishingContractsDetails.initialBalancePeriod },
    getPublishingContractsDetailsTags                       (state) { return state.publishingContractsDetails.tags },
    getPublishingContractsDetailsReminderDate               (state) { return state.publishingContractsDetails.reminderDate },
    getPublishingContractsDetailsContractDate               (state) { return state.publishingContractsDetails.contractDate },
    getPublishingContractsDetailsValidFromDate              (state) { return state.publishingContractsDetails.validFrom },
    getPublishingContractsDetailsValidUntilDate             (state) { return state.publishingContractsDetails.validUntil },
    getPublishingContractsDetailsGemaContractType           (state) { return state.publishingContractsDetails.gemaContractType },
    getPublishingContractsDetailsRefunding                  (state) { return state.publishingContractsDetails.refunding },
    getPublishingContractsDetailsSpTresholdPr               (state) { return state.publishingContractsDetails.spTresholdPr },
    getPublishingContractsDetailsSpTresholdMr               (state) { return state.publishingContractsDetails.spTresholdMr },
    getPublishingContractsDetailsNumberOfAssignedWorks      (state) { return state.publishingContractsDetails.numberOfAssignedWorks },
    getPublishingContractsDetailsNumberOfAssignedWorksContract(state) { return state.publishingContractsDetails.numberOfAssignedWorksContract },
    getPublishingContractsDetailsNumberOfAssignedWorksSubCatalogue(state) { return state.publishingContractsDetails.numberOfAssignedWorksSubcatalogue },
    getPublishingContractsDetailsArColl                     (state) { return state.publishingContractsDetails.arColl },
    getPublishingContractsDetailsMrColl                     (state) { return state.publishingContractsDetails.mrColl },
    getPublishingContractsDetailsShareFrom                  (state) { return state.publishingContractsDetails.mrCollShareFrom },
    getPublishingContractsDetailsSvdForSpw                  (state) { return state.publishingContractsDetails.svdForSpw },
    getPublishingContractsDetailsSourceAdaption             (state) { return state.publishingContractsDetails.sourceAdaption },
    // Period
    getSelectedPeriodNumberPublishingContracts (state) { 
        if(state.publishingContractsDetails.initialBalancePeriod !== undefined){
            return state.publishingContractsDetails.initialBalancePeriod.num 
        }else{
            return null
        }
    },
    getSelectedPeriodTimeUnitPublishingContracts (state) { 
        if(state.publishingContractsDetails.initialBalancePeriod !== undefined){
            return state.publishingContractsDetails.initialBalancePeriod.period 
        }else{
            return null
        }
    },
    getSelectedPeriodYearPublishingContracts (state) { 
        if(state.publishingContractsDetails.initialBalancePeriod !== undefined){
            return state.publishingContractsDetails.initialBalancePeriod.year 
        }else{
            return null
        }
    },

    // WORKS PANEL
    getPublishingContractsWorks(state) { return state.publishingContractsWorks },
    getSelectedContractPublishingWork(state) { return state.selectedContractPublishingWork },    
    getSelectedWorksForContract(state) { return state.selectedWorksForContract },
    getWorksForContractSearch(state) { return state.worksForContractSearch },
    getTotalWorksForContractListed(state) { return state.totalWorksForContractListed },
    getTotalWorksForContractRecords(state) { return state.totalWorksForContractRecords },
    getPublishingContractsWorksSearch(state) { return state.publishingContractsWorksSearch },
    getShowWorksDeleteResultListButton(state) { return state.showWorksDeleteResultListButton },
    getShowSetWorksTypeDialog(state)                        { return state.showSetWorksTypeDialog },
    getWorksSearchId(state) { return state.worksSearchId },

    // SPLITS PANEL
    getDefaultPublishingContractSplits(state) { return state.defaultPublishingContractSplits },   
    getPublishingContractSplits(state) { return state.publishingContractSplits },
    getSelectedPublishingContractSplits(state) { return state.selectedPublishingContractSplits },
    getPublishingContractTypeOfRights(state) { return state.publishingContractTypeOfRights },
    // EDIT PANEL
    getSelectedPublishingContractsMediaFiles(state) { return state.selectedPublishingContractsMediaFiles },
    // Edit Dialog
    getPublishingContractSplitsEditingDialogDetails(state) { return state.publishingContractSplitsEditingDialogDetails }, 
    getPublishingContractSplitsDetailsSplit(state) { return state.publishingContractSplitsEditingDialogDetails.split },
    getPublishingContractSplitsDetailsBase(state) { return state.publishingContractSplitsEditingDialogDetails.base },
    getPublishingContractSplitsDetailsRights(state) { return state.publishingContractSplitsEditingDialogDetails.rights },
    getPublishingContractSplitsDetailsApplyTo(state) { return state.publishingContractSplitsEditingDialogDetails.applyTo },
    // Regions
    getPublishingContractSplitsEditingDialogIncludeOptions(state) { return state.publishingContractSplitsEditingDialogIncludeOptions },
    getPublishingContractSplitsEditingDialogExcludeOptions(state) { return state.publishingContractSplitsEditingDialogExcludeOptions },
    getPublishingContractSplitsEditingDialogDetailsInclude(state) { 
        if(state.publishingContractSplitsEditingDialogDetails.region === undefined) return []
        else return state.publishingContractSplitsEditingDialogDetails.region.include 
    },
    getPublishingContractSplitsEditingDialogDetailsExclude(state) { 
        if(state.publishingContractSplitsEditingDialogDetails.region === undefined) return []
        else return state.publishingContractSplitsEditingDialogDetails.region.exclude 
    },

    // Conditions
    getPublishingContractConditionsRecipientIdOptions(state) { return state.publishingContractConditionsRecipientIdOptions },
    getPublishingContractConditionsEditingDialogDetails(state) { return state.publishingContractConditionsEditingDialogDetails },
    getDefaultPublishingContractConditions(state) { return state.defaultPublishingContractConditions },
    getPublishingContractConditions(state) { return state.publishingContractConditions },
    getSelectedPublishingContractConditions(state) { return state.selectedPublishingContractConditions },
    getPublishingContractDetailsRecipientId(state) {return state.publishingContractDetailsRecipientId },
    getPublishingContractDetailsSplitsRecipientId(state) {return state.publishingContractDetailsSplitsRecipientId },
    getShowPublishingContractConditionsEditingDialog: (state)  => { return state.showPublishingContractConditionsEditingDialog },
    getActiveConditionId: (state)  => { return state.activeConditionId },
    
    // CONDITIONS SPLITS PANEL
    getPublishingContractConditionsSplitsDetailsRecipientId(state) { return state.publishingContractConditionsSplitsDetailsRecipientId },
    // getPublishingContractConditionsSplitsDetailsRecipientId(state) { return state.publishingContractConditionsSplitsEditingDialogDetails.recipientId },
    getDefaultPublishingContractConditionsSplits(state) { return state.defaultPublishingContractConditionsSplits },
    getPublishingContractConditionsSplits(state) { return state.publishingContractConditionsSplits },
    getSelectedPublishingContractConditionsSplits(state) { return state.selectedPublishingContractConditionsSplits },
    getPublishingContractConditionsSplitsEditingDialog(state) { return state.showPublishingContractConditionsSplitsEditingDialog },
    getShowPublishingContractConditionsSplitsEditingDialog: (state)  => { return state.showPublishingContractConditionsSplitsEditingDialog },
    
    // Edit Dialog (Conditions)
    getPublishingContractConditionsDetailsRecipientId:          (state) => { return state.publishingContractConditionsEditingDialogDetails.recipientId },
    getPublishingContractConditionsDetailsSourceId:             (state) => { return state.publishingContractConditionsEditingDialogDetails.sourceId },
    getPublishingContractConditionsDetailsSvavPublisherQuota:   (state) => { return state.publishingContractConditionsEditingDialogDetails.svavPublisherQuota; },
    getPublishingContractConditionsDetailsSvavShareType:        (state) => { return state.publishingContractConditionsEditingDialogDetails.svavShareType },
    getPublishingContractConditionsSplitsEditingDialogDetails:  (state) => { return state.publishingContractConditionsSplitsEditingDialogDetails },
    getPublishingContractConditionsSplitsRecipientIdOptions:    (state) => { return state.publishingContractConditionsSplitsRecipientIdOptions },
    getPublishingContractConditionsSplitsSharesToConsiderOptions: (state) => { return state.publishingContractConditionsSplitsSharesToConsiderOptions },
    getAzPersonsCache: (state) => { return state.azPersonsCache },
    
    getPublishingContractConditionsSplitsDetailsRightsType:     (state) => { return state.publishingContractConditionsSplitsDetailsRightsType},
    getPublishingContractConditionsSplitsDetailsCategory:       (state) => { return state.publishingContractConditionsSplitsDetailsCategory},
    getPublishingContractConditionsSplitsDetailsSubCategory:    (state) => { return state.publishingContractConditionsSplitsDetailsSubCategory},
    getPublishingContractConditionsSplitsDetailsSplit:          (state) => { return state.publishingContractConditionsSplitsDetailsSplit},
    getPublishingContractConditionsSplitsDetailsWeighting:      (state) => { return state.publishingContractConditionsSplitsDetailsWeighting },
    getPublishingContractConditionsSplitsDetailsWeightingSource:(state) => { return state.publishingContractConditionsSplitsDetailsWeightingSource },
    getPublishingContractConditionsSplitsDetailsSharesToConsider:(state) => { return state.publishingContractConditionsSplitsDetailsSharesToConsider },
    getPublishingContractConditionsSplitsDetailsApplyTo:        (state) => { return state.publishingContractConditionsSplitsDetailsApplyTo},
    getPublishingContractConditionsSplitsDetailsOrder:          (state) => { return state.publishingContractConditionsSplitsDetailsOrder },
    getPublishingContractConditionsSplitsDetailsBase:           (state) => { return state.publishingContractConditionsSplitsDetailsBase},
    // Regions - conditions > splits
    getPublishingContractConditionsSplitsIncludeOptions:    (state) => { return state.publishingContractConditionsSplitsIncludeOptions },
    getPublishingContractConditionsSplitsExcludeOptions:    (state) => { return state.publishingContractConditionsSplitsExcludeOptions },
    getPublishingContractConditionsSplitsDetailsInclude:    (state) => { return state.publishingContractConditionsSplitsDetailsInclude },
    getPublishingContractConditionsSplitsDetailsExclude:    (state) => { return state.publishingContractConditionsSplitsDetailsExclude },

    
    

    // GROUPED CONTRACTS Panel
    getPublishingContractsGroupedContracts(state) { return state.publishingContractsGroupedContracts },
    getShowPublishingContractsGroupDialog(state) { return state.showPublishingContractsGroupDialog },
    getPublishingContractsGroupDialogName(state) { return state.publishingContractsGroupDialogName },
    getPublishingContractsDetailGroupName(state) {
        let details = state.publishingContractsDetails
        if(details && details.groupName) return details.groupName
        return ''
    },

    // AGREEMENT NUMBERS PANEL
    getPublishingContractsAgreementNumbers(state) { return state.publishingContractsAgreementNumbers },
    getSelectedPublishingContractsAgreementNumbers(state) { return state.selectedPublishingContractsAgreementNumbers },
    getDefaultPublishingContractsAgreementNumbers(state) { return state.defaultPublishingContractsAgreementNumbers },
    getShowPublishingContractsAgreementNumbersEditingDialog(state) { return state.showPublishingContractsAgreementNumbersEditingDialog },
    getPublishingContractsAgreementNumbersEditingDialogDetails(state) { return state.publishingContractsAgreementNumbersEditingDialogDetails },
    getPublishingContractsAgreementNumbersDetailsSubcatalogId(state) { return state.publishingContractsAgreementNumbersEditingDialogDetails.subcatalogId },
    getPublishingContractsAgreementNumbersDetailsSourceAlvId(state) { return state.publishingContractsAgreementNumbersEditingDialogDetails.sourceAlvId },
    getPublishingContractsAgreementNumbersDetailsAgreementNumber(state) { return state.publishingContractsAgreementNumbersEditingDialogDetails.agreementNumber },

    // ADVANCE PANEL
    getPublishingContractsAdvance(state) { return state.publishingContractsAdvance },
    getSelectedPublishingContractsAdvance(state) { return state.selectedPublishingContractsAdvance },
    getDefaultPublishingContractsAdvance(state) { return state.defaultPublishingContractsAdvance },
    getShowPublishingContractsAdvanceEditingDialog(state) { return state.showPublishingContractsAdvanceEditingDialog },
    getPublishingContractsAdvanceEditingDialogDetails(state) { return state.publishingContractsAdvanceEditingDialogDetails },
    getPublishingContractsAdvanceDetailsDescription(state) { return state.publishingContractsAdvanceEditingDialogDetails.description },
    getPublishingContractsAdvanceDetailsAmount(state) { return state.publishingContractsAdvanceEditingDialogDetails.amount },
    getPublishingContractsAdvanceDetailsBalance(state) { return state.publishingContractsAdvanceEditingDialogDetails.balance },

    // COSTS PANEL
    getPublishingContractsCosts(state) { return state.publishingContractsCosts },
    getSelectedPublishingContractsCosts(state) { return state.selectedPublishingContractsCosts },
    getDefaultPublishingContractsCosts(state) { return state.defaultPublishingContractsCosts },
    getShowPublishingContractsCostsEditingDialog(state) { return state.showPublishingContractsCostsEditingDialog },
    getPublishingContractsCostsAssignToWorkOptions(state) { return state.publishingContractsCostsAssignToWorkOptions },
    getPublishingContractsCostsEditingDialogDetails(state) { return state.publishingContractsCostsEditingDialogDetails },
    getPublishingContractsCostsDetailsCostGroup(state) { return state.publishingContractsCostsEditingDialogDetails.costGroup },
    getPublishingContractsCostsDetailsDate(state) { return state.publishingContractsCostsEditingDialogDetails.date },
    getPublishingContractsCostsDetailsPaidOn(state) { return state.publishingContractsCostsEditingDialogDetails.paidOn },
    getPublishingContractsCostsDetailsAmount(state) { return state.publishingContractsCostsEditingDialogDetails.amount },
    getPublishingContractsCostsDetailsSplit(state) { return state.publishingContractsCostsEditingDialogDetails.split },
    getPublishingContractsCostsDetailsCountry(state) { return state.publishingContractsCostsEditingDialogDetails.country },
    getPublishingContractsCostsDetailsDescription(state) { return state.publishingContractsCostsEditingDialogDetails.description },
    getPublishingContractsCostsDetailsDocumentNumber(state) { return state.publishingContractsCostsEditingDialogDetails.documentNumber },
    getPublishingContractsCostsDetailsAssignToWork(state) { return state.publishingContractsCostsEditingDialogDetails.assignToWork },
    getPublishingContractsCostsDetailsRecipient(state) { return state.publishingContractsCostsEditingDialogDetails.recipient },
    getPublishingContractsCostsRecipientOptions(state) { return state.publishingContractsCostsRecipientOptions },
    getPublishingContractsCostsDetailsAccountingPeriod(state) { return state.publishingContractsCostsEditingDialogDetails.accountingPeriod },
    getSelectedPeriodNumberPublishingContractsCostsAccountingPeriod(state) { return state.publishingContractsCostsEditingDialogDetails.accountingPeriod.num },
    getSelectedPeriodTimeUnitPublishingContractsCostsAccountingPeriod(state) { return state.publishingContractsCostsEditingDialogDetails.accountingPeriod.period },
    getSelectedPeriodYearPublishingContractsCostsAccountingPeriod(state) { return state.publishingContractsCostsEditingDialogDetails.accountingPeriod.year },
    getPublishingContractsCostsTotalRecords(state) { return state.publishingContractsCostsTotalRecords },
    getPublishingContractsCostsTotalListed(state) { return state.publishingContractsCostsTotalListed },
    getPublishingContractsCostsCurrentPage(state) { return state.publishingContractsCostsCurrentPage },
    getPublishingContractsCostsNumberOfPages(state) { return state.publishingContractsCostsNumberOfPages },

    // SUB-CATALOGUES PANEL
    getPublishingContractsSubCatalogues(state) { return state.publishingContractsSubCatalogues },
    getSelectedPublishingContractsSubCatalogues(state) { return state.selectedPublishingContractsSubCatalogues },
    getPublishingContractsSubCataloguesWorksSearch(state) { return state.publishingContractsSubCataloguesWorksSearch },
    getShowSubCataloguesWorksDeleteResultListButton(state) { return state.showSubCataloguesWorksDeleteResultListButton },
    getSubCataloguesWorksSearchId(state) { return state.subCataloguesWorksSearchId },
    // Edit sub cat
    getDefaultPublishingContractsSubCatalogues(state) { return state.defaultPublishingContractsSubCatalogues },
    getPublishingContractsSubCataloguesEditingDialogDetails(state) { return state.publishingContractsSubCataloguesEditingDialogDetails },
    getPublishingContractsSubCataloguesDetailsLicensor(state) { return state.publishingContractsSubCataloguesEditingDialogDetails.licensor },
    getPublishingContractsSubCataloguesDetailsAgreementNumber(state) { return state.publishingContractsSubCataloguesEditingDialogDetails.gemaAgreementNo },
    getPublishingContractsSubCataloguesDetailsScheduleNumber(state) { return state.publishingContractsSubCataloguesEditingDialogDetails.gemaScheduleNo },
    getPublishingContractsSubCataloguesDetailsNotes(state) { return state.publishingContractsSubCataloguesEditingDialogDetails.notes },
    getPublishingContractsSubCataloguesDetailsValidUntil(state) { return state.publishingContractsSubCataloguesEditingDialogDetails.validUntil },
    getPublishingContractsSubCataloguesDetailsProcessableUntil(state) { return state.publishingContractsSubCataloguesEditingDialogDetails.processableUntil },
    // Licensor Autocomplete
    getPublishingContractsSubCataloguesLicensorOptions(state) { return state.publishingContractsSubCataloguesLicensorOptions },
    // Edit works sub-catalogues
    getPublishingContractsSubCataloguesWorks(state) { return state.publishingContractsSubCataloguesWorks },
    getShowSearchSubCataloguesWorksDialog(state) { return state.showSearchSubCataloguesWorksDialog },
    getWorksForSubCataloguesSearch(state) { return state.worksForSubCataloguesSearch },
    getSelectedWorksForSubCatalogues(state) { return state.selectedWorksForSubCatalogues },
    // MEDIA Panel
    getPublishingContractsMedia (state) { return state.publishingContractsMedia},
    getPublishingContractsMediaCheckbox(state) { return state.publishingContractsMediaCheckbox},
}

const mutations = {
// Edit
    setShowEditSplitDialog: (state, payload) => { state.showEditSplitDialog = payload },
    setShowConditionDialog: (state, payload) => { state.showConditionDialog = payload },
    setPublishingContractEditSplitsDetailsWeighting: (state, payload) => { state.editSplitsDetailsWeighting = payload },
    setPublishingContractEditSplitsDetailsRights: (state, payload) => { state.editSplitsDetailsRights = payload },
    setPublishingContractEditSplitsDetailsCategory: (state, payload) => { state.editSplitsDetailsCategory = payload },
    setPublishingContractEditSplitsDetailsSubcategory: (state, payload) => { state.editSplitsDetailsSubcategory = payload },
    setPublishingContractEditSplitsDetailsSplit: (state, payload) => { state.editSplitsDetailsSplit = payload },
    setPublishingContractEditSplitsDetailsApplyTo: (state, payload) => { state.editSplitsDetailsApplyTo = payload },
    setPublishingContractEditSplitsDetailsBase: (state, payload) => { state.editSplitsDetailsBase = payload },
    setSelectedEditPublishingContractSplits: (state, payload) => { state.selectedEditPublishingContractSplits = payload },
    setSelectedEditPublishingContractConditions: (state, payload) => { state.selectedEditPublishingContractConditions = payload },

// List    
    setPublishingContracts: (state, publishingContractsFromDB) => { state.publishingContracts = publishingContractsFromDB },
    setPublishingReminders: (state, publishingRemindersFromDB) => { state.publishingReminders = publishingRemindersFromDB },
    setSelectedPublishingContracts: (state, selectedPublishingContracts) => { state.selectedPublishingContracts = selectedPublishingContracts },
    setIsAllSelectedPublishingContracts: (state, isSelected) => { state.isAllSelectedPublishingContracts = isSelected },
    setExpandedPublishingContracts: (state, contract) => { state.expandedPublishingContracts = [contract] },
    setPublishingContractsServerSideSortingOptions: (state, options) => { state.publishingContractsServerSideSortingOptions = options },

// Filters
    setPublishingContractsSearch:                           (state, value) => { state.publishingContractsSearch = value },
    setSelectedPublishingContractsQualityFilter:            (state, value) => { state.selectedPublishingContractsQualityFilter = value},

// Actions
    setSelectedPublishingContractsAction:                   (state, value) => { state.selectedPublishingContractsAction = value },
    setPublishingContractsDetailsSelectedCompany:           (state, value) => { state.publishingContractsDetailsSelectedCompany = value },
    setCopyConditionsForPublishingContractsSearch:          (state, value) => { state.copyConditionsForPublishingContractsSearch = value },
    setSelectedCopyConditionsForPublishingContracts:        (state, value) => { state.selectedCopyConditionsForPublishingContracts = value },
    setCopyConditionsForPublishingContractsCsvPath:         (state, value) => { state.copyConditionsForPublishingContractsCsvPath = value },
    setCopyConditionsForPublishingContractsTags:            (state, value) => { state.copyConditionsForPublishingContractsTags = value },
    setCopyConditionsForPublishingContractsAdaptRecipient:  (state, value) => { state.copyConditionsForPublishingContractsAdaptRecipient = value },
    setShowContractsPublishingExportDialog:                 (state, value) => { state.showContractsPublishingExportDialog = value },
    setContractsPublishingExportDetailsType:                (state, value) => { state.contractsPublishingExportType = value },
    setContractsPublishingExportDetailsMappingId:           (state, value) => { state.contractsPublishingExportMappingId = value },
    setContractsPublishingExportAll:                        (state, value) => { state.contractsPublishingExportAll = value },
// Details
    setDefaultNewPublishingContract: (state) => { state.defaultNewPublishingContract = DEFAULT_CONTRACT },
    setPublishingContractsUniqueId: (state, uniqueId) => { state.publishingContractUniqueId = uniqueId },
    setPublishingContractsDetails: (state, details) => {  state.publishingContractsDetails = details },
    setPublishingContractsLicensorOptions: (state, items) => { state.publishingContractsLicensorOptions = items },
    
    // Edit Form Fields
    setPublishingContractsDetailsContractName:              (state, contractName) => { state.publishingContractsDetails.contractName = contractName },
    setPublishingContractsDetailsContractType:              (state, contractType) => { state.publishingContractsDetails.contractType = contractType },
    setPublishingContractsDetailsNotes:                     (state, notes) => { state.publishingContractsDetails.notes = notes },
    setPublishingContractsDetailsInclude: (state, include) => {
        const territories = ensurePublishingContractTerritories(state.publishingContractsDetails)
        territories.include = publishingTerritoryCodes(include)
    },
    setPublishingContractsDetailsExclude: (state, exclude) => {
        const territories = ensurePublishingContractTerritories(state.publishingContractsDetails)
        territories.exclude = publishingTerritoryCodes(exclude)
    },
    setPublishingContractsIncludeOptions: (state, options) => { state.publishingContractsIncludeOptions = options },
    setPublishingContractsExcludeOptions: (state, options) => { state.publishingContractsExcludeOptions = options },
    setPublishingContractsDetailsAlvId:                     (state, alvId) => { state.publishingContractsDetails.alvId = alvId },
    setPublishingContractsDetailsGemaAgreementNo:           (state, number) => { state.publishingContractsDetails.gemaAgreementNo = number },
    setPublishingContractsDetailsGemaScheduleNo:            (state, number) => { state.publishingContractsDetails.gemaScheduleNo = number },
    setPublishingContractsDetailsInitialBalance:            (state, initialBalance) => { state.publishingContractsDetails.initialBalance = initialBalance },
    setPublishingContractsDetailsInitialBalancePeriod:      (state, initialBalancePeriod) => { state.publishingContractsDetails.initialBalancePeriod = initialBalancePeriod },
    setPublishingContractsDetailsTags:                      (state, value) => { state.publishingContractsDetails.tags = value },
    setPublishingContractsDetailsReminderDate:              (state, date) => { state.publishingContractsDetails.reminderDate = date },
    setPublishingContractsDetailsContractDate:              (state, date) => { state.publishingContractsDetails.contractDate = date },
    setPublishingContractsDetailsValidFromDate:             (state, date) => { state.publishingContractsDetails.validFrom = date },
    setPublishingContractsDetailsValidUntilDate:            (state, date) => { state.publishingContractsDetails.validUntil = date },
    setPublishingContractsDetailsGemaContractType:          (state, contractType) => { state.publishingContractsDetails.gemaContractType = contractType },
    setPublishingContractsDetailsRefunding:                 (state, refunding) => { state.publishingContractsDetails.refunding = refunding },
    setPublishingContractsDetailsSpTresholdPr:              (state, value) => { state.publishingContractsDetails.spTresholdPr = value },
    setPublishingContractsDetailsSpTresholdMr:              (state, value) => { state.publishingContractsDetails.spTresholdMr = value },    
    setPublishingContractsDetailsNumberOfAssignedWorks:     (state, number) => { state.publishingContractsDetails.numberOfAssignedWorks = number },
    setPublishingContractsDetailsNumberOfAssignedWorksContract: (state, number) => { state.publishingContractsDetails.numberOfAssignedWorksContract = number },
    setPublishingContractsDetailsNumberOfAssignedWorksSubCatalogue: (state, number) => { state.publishingContractsDetails.numberOfAssignedWorksSubcatalogue = number },
    setPublishingContractsDetailsArColl:                    (state, arColl) => { state.publishingContractsDetails.arColl = arColl },
    setPublishingContractsDetailsMrColl:                    (state, mrColl) => { state.publishingContractsDetails.mrColl = mrColl },
    setPublishingContractsDetailsShareFrom:                 (state, shareFrom) => {  state.publishingContractsDetails.mrCollShareFrom = shareFrom },
    setPublishingContractsDetailsSvdForSpw:                 (state, value) => { state.publishingContractsDetails.svdForSpw = value },
    setPublishingContractsDetailsSourceAdaption:            (state, value) => { state.publishingContractsDetails.sourceAdaption = value },
    setPublishingContractsDetailsLicensor:                  (state, licensor) => { state.publishingContractsDetails.licensor = licensor }, 
    // Period
    setSelectedPeriodNumberPublishingContracts: (state, num) => { state.publishingContractsDetails.initialBalancePeriod.num = num },
    setSelectedPeriodTimeUnitPublishingContracts: (state, period) => { state.publishingContractsDetails.initialBalancePeriod.period = period },
    setSelectedPeriodYearPublishingContracts: (state, year) => { state.publishingContractsDetails.initialBalancePeriod.year = year },
    // WORKS PANEL
    setPublishingContractsWorks: (state, publishingContractsWorks) => { state.publishingContractsWorks = publishingContractsWorks },     
    setSelectedContractPublishingWork: (state, selected) => { state.selectedContractPublishingWork = selected },
    setSelectedWorksForContract: (state, selectedWorksForContract) => { state.selectedWorksForContract = selectedWorksForContract },    
    setWorksForContractSearch: (state, search) => { state.worksForContractSearch = search },
    setTotalWorksForContractListed(state, value) { state.totalWorksForContractListed = value },
    setTotalWorksForContractRecords(state, value) { state.totalWorksForContractRecords = value },
    setPublishingContractsWorksSearch: (state, search) => { state.publishingContractsWorksSearch = search },
    setShowWorksDeleteResultListButton: (state, show) => { state.showWorksDeleteResultListButton = show },
    setShowSetWorksTypeDialog:                              (state, value) => { state.showSetWorksTypeDialog = value },
    setWorksSearchId: (state, id) => { state.worksSearchId = id },

    // SPLITS PANEL
    setDefaultPublishingContractSplits: (state) => { state.defaultPublishingContractSplits = DEFAULT_SPLITS },
    setPublishingContractSplits: (state, splits) => { state.publishingContractSplits = splits },
    setSelectedPublishingContractSplits: (state, idsArr) => { state.selectedPublishingContractSplits = idsArr },
    setPublishingContractTypeOfRights: (state, items) => { state.publishingContractTypeOfRights = items },
    // Edit Dialog
    setPublishingContractSplitsEditingDialogDetails: (state, details) => { state.publishingContractSplitsEditingDialogDetails = details },
    setPublishingContractSplitsDetailsSplit: (state, split) => { state.publishingContractSplitsEditingDialogDetails.split = split },
    setPublishingContractSplitsDetailsBase: (state, base) => { state.publishingContractSplitsEditingDialogDetails.base = base },
    setPublishingContractSplitsDetailsRights: (state, rights) => { state.publishingContractSplitsEditingDialogDetails.rights = rights },
    setPublishingContractSplitsDetailsApplyTo: (state, applyTo) => { state.publishingContractSplitsEditingDialogDetails.applyTo = applyTo },
    // Regions
    setPublishingContractSplitsEditingDialogIncludeOptions: (state, options) => { state.publishingContractSplitsEditingDialogIncludeOptions = options },
    setPublishingContractSplitsEditingDialogExcludeOptions: (state, options) => { state.publishingContractSplitsEditingDialogExcludeOptions = options },
    setPublishingContractSplitsEditingDialogDetailsInclude: (state, include) => { state.publishingContractSplitsEditingDialogDetails.region.include = include },
    setPublishingContractSplitsEditingDialogDetailsExclude: (state, exclude) => { state.publishingContractSplitsEditingDialogDetails.region.exclude = exclude },

    // Conditions
    setPublishingContractConditionsRecipientIdOptions:(state, value) => { state.publishingContractConditionsRecipientIdOptions = value },
    setPublishingContractConditionsEditingDialogDetails: (state, value) => { state.publishingContractConditionsEditingDialogDetails = value },
    setPublishingContractDetailsRecipientId: (state, value)  => { state.publishingContractDetailsRecipientId = value },
    setShowPublishingContractConditionsEditingDialog: (state, value)  => { state.showPublishingContractConditionsEditingDialog = value },

    // CONDITIONS PANEL
    setPublishingContractDetailsSplitsRecipientId: (state, value)  => { state.publishingContractDetailsSplitsRecipientId = value },
    setDefaultPublishingContractConditions: (state, value) => { state.defaultPublishingContractConditions = value },
    setPublishingContractConditions: (state, value) => { state.publishingContractConditions = value },
    setSelectedPublishingContractConditions: (state, value) => { state.selectedPublishingContractConditions = value },
    setPublishingContractConditionsSplitsEditingDialogDetails: (state, value) => { state.publishingContractConditionsSplitsEditingDialogDetails = value },
    
    setPublishingContractConditionsSplitsDetailsRecipientId:(state, value) => { state.publishingContractConditionsSplitsDetailsRecipientId = value },
    setPublishingContractConditionsSplitsRecipientIdOptions: (state, value) => { state.publishingContractConditionsSplitsRecipientIdOptions = value },
    setPublishingContractConditionsSplitsSharesToConsiderOptions: (state, value) => { state.publishingContractConditionsSplitsSharesToConsiderOptions = value },
    // A-Z Persons Cache Management
    setAzPersonInCache: (state, { alvId, azObject }) => { state.azPersonsCache[alvId] = azObject },
    clearAzPersonsCache: (state) => { state.azPersonsCache = {} },
    
     // CONDITIONS SPLITS PANEL
    setDefaultPublishingContractConditionsSplits: (state, value) => { state.defaultPublishingContractConditionsSplits = value },
    setPublishingContractConditionsSplits: (state, value) => { state.publishingContractConditionsSplits = value },
    setSelectedPublishingContractConditionsSplits: (state, value) => { state.selectedPublishingContractConditionsSplits = value },
    setShowPublishingContractConditionsSplitsEditingDialog: (state, value) => { state.showPublishingContractConditionsSplitsEditingDialog = value },

    // Edit Dialog conditions
    setPublishingContractConditionsDetailsSourceId:             (state, value) => { state.publishingContractConditionsEditingDialogDetails.sourceId = value },
    setPublishingContractConditionsDetailsRecipientId:          (state, value) => { state.publishingContractConditionsEditingDialogDetails.recipientId = value },
    setPublishingContractConditionsDetailsSvavPublisherQuota:   (state, value) => { state.publishingContractConditionsEditingDialogDetails.svavPublisherQuota = value },
    setPublishingContractConditionsDetailsSvavShareType:        (state, value) => { state.publishingContractConditionsEditingDialogDetails.svavShareType = value },

    setPublishingContractConditionsSplitsDetailsRightsType:     (state, value) => { state.publishingContractConditionsSplitsDetailsRightsType = value},
    setPublishingContractConditionsSplitsDetailsCategory:       (state, value) => { state.publishingContractConditionsSplitsDetailsCategory = value},
    setPublishingContractConditionsSplitsDetailsSubCategory:    (state, value) => { state.publishingContractConditionsSplitsDetailsSubCategory = value},
    setPublishingContractConditionsSplitsDetailsSplit:          (state, value) => { state.publishingContractConditionsSplitsDetailsSplit = value},
    setPublishingContractConditionsSplitsDetailsWeighting:      (state, value) => { state.publishingContractConditionsSplitsDetailsWeighting = value},
    setPublishingContractConditionsSplitsDetailsWeightingSource:(state, value) => { state.publishingContractConditionsSplitsDetailsWeightingSource = value },
    setPublishingContractConditionsSplitsDetailsSharesToConsider:(state, value) => { state.publishingContractConditionsSplitsDetailsSharesToConsider = value },
    setPublishingContractConditionsSplitsDetailsApplyTo:        (state, value) => { state.publishingContractConditionsSplitsDetailsApplyTo = value},
    setPublishingContractConditionsSplitsDetailsOrder:          (state, value) => { state.publishingContractConditionsSplitsDetailsOrder = value},
    setPublishingContractConditionsSplitsDetailsBase:           (state, value) => { state.publishingContractConditionsSplitsDetailsBase = value},
    setPublishingContractConditionsSplitsIncludeOptions:        (state, value) => { state.publishingContractConditionsSplitsIncludeOptions = value},
    setPublishingContractConditionsSplitsExcludeOptions:        (state, value) => { state.publishingContractConditionsSplitsExcludeOptions = value},
    setPublishingContractConditionsSplitsDetailsInclude:        (state, value) => { state.publishingContractConditionsSplitsDetailsInclude = value},
    setPublishingContractConditionsSplitsDetailsExclude:        (state, value) => { state.publishingContractConditionsSplitsDetailsExclude = value},
    setActiveConditionId: (state, value)  => { state.activeConditionId = value },


    // GROUPED CONTRACTS Panel
    setPublishingContractsGroupedContracts: (state, contracts) => { state.publishingContractsGroupedContracts = contracts },
    setShowPublishingContractsGroupDialog: (state, show) => { state.showPublishingContractsGroupDialog = show },
    setPublishingContractsGroupDialogName: (state, name) => { state.publishingContractsGroupDialogName = name },

    // AGREEMENT NUMBERS PANEL
    setPublishingContractsAgreementNumbers: (state, value) => { state.publishingContractsAgreementNumbers = value },
    setSelectedPublishingContractsAgreementNumbers: (state, selected) => { state.selectedPublishingContractsAgreementNumbers = selected },
    setDefaultPublishingContractsAgreementNumbers: (state) => { state.defaultPublishingContractsAgreementNumbers = DEFAULT_AGREEMENT_NUMBER },
    setShowPublishingContractsAgreementNumbersEditingDialog: (state, show) => { state.showPublishingContractsAgreementNumbersEditingDialog = show },
    setPublishingContractsAgreementNumbersEditingDialogDetails: (state, details) => { state.publishingContractsAgreementNumbersEditingDialogDetails = details },
    setPublishingContractsAgreementNumbersDetailsSubcatalogId: (state, value) => { state.publishingContractsAgreementNumbersEditingDialogDetails.subcatalogId = value },
    setPublishingContractsAgreementNumbersDetailsSourceAlvId: (state, value) => { state.publishingContractsAgreementNumbersEditingDialogDetails.sourceAlvId = value },
    setPublishingContractsAgreementNumbersDetailsAgreementNumber: (state, value) => { state.publishingContractsAgreementNumbersEditingDialogDetails.agreementNumber = value },

    // ADVANCE PANEL
    setPublishingContractsAdvance: (state, advance) => { state.publishingContractsAdvance = advance },
    setSelectedPublishingContractsAdvance: (state, selected) => { state.selectedPublishingContractsAdvance = selected },
    setDefaultPublishingContractsAdvance: (state) => { state.defaultPublishingContractsAdvance = DEFAULT_ADVANCE },
    setShowPublishingContractsAdvanceEditingDialog: (state, show) => { state.showPublishingContractsAdvanceEditingDialog = show },
    setPublishingContractsAdvanceEditingDialogDetails: (state, details) => { state.publishingContractsAdvanceEditingDialogDetails = details },
    setPublishingContractsAdvanceDetailsDescription: (state, text) => { state.publishingContractsAdvanceEditingDialogDetails.description = text },
    setPublishingContractsAdvanceDetailsAmount: (state, amount) => { state.publishingContractsAdvanceEditingDialogDetails.amount = amount },
    setPublishingContractsAdvanceDetailsBalance: (state, balance) => { state.publishingContractsAdvanceEditingDialogDetails.balance = balance },

    // COSTS PANEL
    setPublishingContractsCosts: (state, costs) => { state.publishingContractsCosts = costs },
    setSelectedPublishingContractsCosts: (state, selected) => { state.selectedPublishingContractsCosts = selected },
    setDefaultPublishingContractsCosts: (state) => { state.defaultPublishingContractsCosts = DEFAULT_COSTS },
    setShowPublishingContractsCostsEditingDialog: (state, show) => { state.showPublishingContractsCostsEditingDialog = show },
    setPublishingContractsCostsEditingDialogDetails: (state, details) => { state.publishingContractsCostsEditingDialogDetails = details },
    setPublishingContractsCostsRecipientOptions: (state, options) => { state.publishingContractsCostsRecipientOptions = options },
    setPublishingContractsCostsAssignToWorkOptions: (state, options) => { state.publishingContractsCostsAssignToWorkOptions = options },
    setPublishingContractsCostsTotalRecords: (state, value) => { state.publishingContractsCostsTotalRecords = value },
    setPublishingContractsCostsTotalListed: (state, value) => { state.publishingContractsCostsTotalListed = value },
    setPublishingContractsCostsCurrentPage: (state, page) => { state.publishingContractsCostsCurrentPage = page },
    setPublishingContractsCostsNumberOfPages: (state, pages) => { state.publishingContractsCostsNumberOfPages = pages },
    setPublishingContractsCostsDetailsCostGroup: (state, value) => { state.publishingContractsCostsEditingDialogDetails.costGroup = value },
    setPublishingContractsCostsDetailsDate: (state, value) => { state.publishingContractsCostsEditingDialogDetails.date = value },
    setPublishingContractsCostsDetailsPaidOn: (state, value) => { state.publishingContractsCostsEditingDialogDetails.paidOn = value },
    setPublishingContractsCostsDetailsAmount: (state, value) => { state.publishingContractsCostsEditingDialogDetails.amount = value },
    setPublishingContractsCostsDetailsSplit: (state, value) => { state.publishingContractsCostsEditingDialogDetails.split = value },
    setPublishingContractsCostsDetailsCountry: (state, value) => { state.publishingContractsCostsEditingDialogDetails.country = value },
    setPublishingContractsCostsDetailsDescription: (state, value) => { state.publishingContractsCostsEditingDialogDetails.description = value },
    setPublishingContractsCostsDetailsDocumentNumber: (state, value) => { state.publishingContractsCostsEditingDialogDetails.documentNumber = value },
    setPublishingContractsCostsDetailsAssignToWork: (state, value) => { state.publishingContractsCostsEditingDialogDetails.assignToWork = value },
    setPublishingContractsCostsDetailsRecipient: (state, value) => { state.publishingContractsCostsEditingDialogDetails.recipient = value },
    setSelectedPeriodNumberPublishingContractsCostsAccountingPeriod: (state, num) => { state.publishingContractsCostsEditingDialogDetails.accountingPeriod.num = num },
    setSelectedPeriodTimeUnitPublishingContractsCostsAccountingPeriod: (state, period) => { state.publishingContractsCostsEditingDialogDetails.accountingPeriod.period = period },
    setSelectedPeriodYearPublishingContractsCostsAccountingPeriod: (state, year) => { state.publishingContractsCostsEditingDialogDetails.accountingPeriod.year = year },

    // SUB-CATALOGUES PANEL
    setPublishingContractsSubCatalogues: (state, catalogue) => { state.publishingContractsSubCatalogues = catalogue },
    setSelectedPublishingContractsSubCatalogues: (state, selected) => { state.selectedPublishingContractsSubCatalogues = selected },
    setPublishingContractsSubCataloguesWorksSearch: (state, search) => { state.publishingContractsSubCataloguesWorksSearch = search },
    setShowSubCataloguesWorksDeleteResultListButton: (state, show) => { state.showSubCataloguesWorksDeleteResultListButton = show },
    setSubCataloguesWorksSearchId: (state, id) => { state.subCataloguesWorksSearchId = id },
    // edit sub cat
    setDefaultPublishingContractsSubCatalogues: (state) => { state.defaultPublishingContractsSubCatalogues = DEFAULT_SUB_CATALOGUE },
    setPublishingContractsSubCataloguesEditingDialogDetails: (state, details) => { state.publishingContractsSubCataloguesEditingDialogDetails = details },
    setPublishingContractsSubCataloguesDetailsLicensor: (state, licensor) => { state.publishingContractsSubCataloguesEditingDialogDetails.licensor = licensor },
    setPublishingContractsSubCataloguesDetailsAgreementNumber: (state, number) => { state.publishingContractsSubCataloguesEditingDialogDetails.gemaAgreementNo = number },
    setPublishingContractsSubCataloguesDetailsScheduleNumber: (state, number) => { state.publishingContractsSubCataloguesEditingDialogDetails.gemaScheduleNo = number },
    setPublishingContractsSubCataloguesDetailsNotes: (state, notes) => { state.publishingContractsSubCataloguesEditingDialogDetails.notes = notes },
    setPublishingContractsSubCataloguesDetailsValidUntil: (state, date) => { state.publishingContractsSubCataloguesEditingDialogDetails.validUntil = date },
    setPublishingContractsSubCataloguesDetailsProcessableUntil: (state, date) => { state.publishingContractsSubCataloguesEditingDialogDetails.processableUntil = date },
    // autocomplete licensor
    setPublishingContractsSubCataloguesLicensorOptions: (state, options) => { state.publishingContractsSubCataloguesLicensorOptions = options },
    // Edit works sub-catalogues
    setPublishingContractsSubCataloguesWorks: (state, works) => { state.publishingContractsSubCataloguesWorks = works },    
    setShowSearchSubCataloguesWorksDialog: (state, show) => { state.showSearchSubCataloguesWorksDialog = show },
    setWorksForSubCataloguesSearch: (state, search) => { state.worksForSubCataloguesSearch = search },
    setSelectedWorksForSubCatalogues: (state, selected) => { state.selectedWorksForSubCatalogues = selected },
    // MEDIA Panel
    setPublishingContractsMedia: (state, media) => { state.publishingContractsMedia = media },
    setPublishingContractsMediaCheckbox: (state, value) => { state.publishingContractsMediaCheckbox = value },
    setSelectedPublishingContractsMediaFiles: (state, mediaFiles) => { state.selectedPublishingContractsMediaFiles = mediaFiles },

}

const actions = {  
// FETCH LIST
    async fetchPublishingContracts( { commit, getters }) {  
        commit('setIsLoading', true)
        
        // check for set filters
        let filterObj = {
            search : getters.getPublishingContractsSearch,
            quality: getters.getSelectedPublishingContractsQualityFilter,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        let options = getters.getPublishingContractsServerSideSortingOptions
        // let response = await api.getListData(DIR, getters.getCurrentPage, paramsString)   
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc,paramsString)   

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPublishingContracts', [])
        } else {
            commit('setPublishingContracts', response.list)
        }  

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },
    
 // FETCH REMINDER LIST
 async fetchPublishingReminders( { commit, getters }) {  
    let reminders
    let res = await api.getReminders(DIR, 'reminder')
    if(res === undefined || res.length === 0 || res.error === 1) {
        commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        reminders = []
    }else{
        reminders=res.list.map(obj => ({ ...obj, source: 'publishing' }))
    }
    commit('setPublishingReminders', reminders)
},

    //MEDIA Panel
    async fetchPublishingContractsMedia({ commit, getters }) {
        commit('setIsLoading', true)
        let alvId = getters.getPublishingContractsDetailsAlvId
        let mediaFromDB = await api.getListData(DIR + '/' + alvId + '/files' , getters.getCurrentPage)

        if(mediaFromDB === undefined || mediaFromDB === null){
            mediaFromDB = []
        } else if(mediaFromDB.length === 0){
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 
        }else{
            mediaFromDB.forEach((element) => {
                element['isPlaying'] = false
            });
        }
        commit('setPublishingContractsMedia', mediaFromDB)

        commit('setIsLoading', false)
    },

    //DELETE MEDIA FILE 

    async deleteSelectedPublishingContractsMediaFiles({getters,commit,dispatch}){
        let alvId = getters.getPublishingContractsDetailsAlvId
        let clickedMediaType = {
            clickedMediaType: getters.getSelectedPublishingContractsMediaFiles[0].type,
            mediaFileId: getters.getSelectedPublishingContractsMediaFiles[0].id,
        }; 
        let response = await api.deleteFile(DIR + "/" + alvId,"?deleteMedia",{"media" : clickedMediaType })
        if(response.error === -1) {
            dispatch("fetchPublishingContractsMedia")
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL')
            })
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }

    },

// FETCH DETAILS
    async fetchPublishingContractsDetails({ commit, getters, dispatch }, alvId) {
        let values
        if(alvId === 'new') {
            let defaultValues = JSON.parse(JSON.stringify(getters.getDefaultNewPublishingContract)) 
            commit('setPublishingContractsSubCatalogues', [])
            values = defaultValues
        } else {
            let response = await api.getDetailsById(DIR, alvId)
            if(response === undefined || response.length === 0 || response.error === 1) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: 'Daten konnten nicht oder nur unvollständig geladen werden'
                })
            } else {
                for (const condition of response.conditions) {
                    for (const split of condition.splits) {
                        split.split = i18n.n(split.split, 'number');
                        split.base = i18n.n(split.base, 'number');

                        const authorWeightings = ['prSelectedAuthorAllUvz', 'prSelectedAuthorAzUvz', 'mrSelectedAuthorAllUvz', 'mrSelectedAuthorAzUvz'];
                        const alvidPattern = /^ALV\d{9}(AP|AG)$/;
                        if (authorWeightings.includes(split.weighting) && typeof split.sharesToConsider === 'string' && alvidPattern.test(split.sharesToConsider)) {
                            split.sharesToConsider = await dispatch('fetchAzPersonByAlvId', split.sharesToConsider);
                        }
                    }
                    condition.svavPublisherQuota = condition.svavPublisherQuota ? i18n.n(condition.svavPublisherQuota, 'number') : null;
                }
                values = response;
            }
        }
        
        if(values.licensor !== null) commit('setPublishingContractsLicensorOptions', [values.licensor])
        if(values.initialBalance !== null) values.initialBalance = i18n.n(values.initialBalance, 'number')
        if(values.initialBalancePeriod === null) values.initialBalancePeriod = { "num": null, "period": null, "year": null}
        const territories = ensurePublishingContractTerritories(values)
        territories.include = publishingTerritoryCodes(territories.include)
        territories.exclude = publishingTerritoryCodes(territories.exclude)
        commit('setPublishingContractsDetails', values)
        // if(alvId !== 'new') dispatch('fetchPublishingContractsWorks')
        dispatch('fetchPublishingContractsAdvance')
        dispatch('fetchPublishingContractsAgreementNumbers')
        dispatch('fetchPublishingContractsGroupedContracts')
        if(alvId !== 'new') dispatch('fetchPublishingContractsCosts')
        else commit('setPublishingContractsCosts', [])
        if(router.currentRoute.name === 'PublishingContractsEdit' && alvId !== 'new') {
            dispatch('fetchPublishingContractsSubCatalogues')
            dispatch('fetchPublishingContractSplitsTypeOfRights')
            dispatch('fetchPublishingContractsMedia')

        }
        commit('setIsLoading', false)
    },

    // AUTOCOMPLETE for LICENSOR
    async fetchAutocompletePublishingContractsLicensor({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setPublishingContractsLicensorOptions', response.list)
    },
// FETCH SPLITS
    async fetchPublishingContractSplits({ commit, getters }){
        let splits = await getters.getPublishingContractsDetails.splits

        if(splits === undefined) return null
        else {
            commit('setIsLoading', false)
            if(splits.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPublishingContractSplits', splits)
        }
    },
    // AUTOCOMPLETE for REGIONS
    async fetchAutocompletePublishingContractsInclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setPublishingContractsIncludeOptions', items)
    },
    async fetchAutocompletePublishingContractsExclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setPublishingContractsExcludeOptions', items)
    },
    async fetchAutocompletePublishingContractSplitsEditingDialogInclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setPublishingContractSplitsEditingDialogIncludeOptions', items)
    },
    async fetchAutocompletePublishingContractSplitsEditingDialogExclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setPublishingContractSplitsEditingDialogExcludeOptions', items)
    },

    // AUTOCOMPLETE for REGIONS (Splits dialog)
    async fetchAutocompletePublishingContractConditionsSplitsInclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setPublishingContractConditionsSplitsIncludeOptions', items)
    },
    async fetchAutocompletePublishingContractConditionsSplitsExclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setPublishingContractConditionsSplitsExcludeOptions', items)
    },


    // DELETE Splits
    deleteSelectedPublishingContractSplits({ getters, commit }) {
        let id = getters.getSelectedPublishingContractSplits[0] // only one id is passed
        let index = state.publishingContractSplits.findIndex(split => split.id == id)

        let startSplitsAmount = getters.getPublishingContractSplits.length
        Vue.delete(state.publishingContractSplits, index)
        let newSplitsAmount = getters.getPublishingContractSplits.length
        commit("setSelectedPublishingContractSplits", [])

        if(startSplitsAmount > newSplitsAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_CONTRACTS_PUBLISHING_SNACKBAR_DELETE_SHARES_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_CONTRACTS_PUBLISHING_SNACKBAR_DELETE_SHARES_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedPublishingContractSplits', [])
        if(newSplitsAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },
    async fetchPublishingContractSplitsTypeOfRights({ getters, commit }) {
        let alvId = getters.getPublishingContractsDetailsAlvId
        let typeOfRights = await api.getDropdownValues(DIR, 'typeOfRights')
        commit('setPublishingContractTypeOfRights', typeOfRights.response)
    },

// FETCH WORKS
    async fetchPublishingContractsWorks({ commit, getters }){    
        commit('setIsLoading', true)    
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        
        // search filter
        let searchInput = getters.getPublishingContractsWorksSearch
        let filterObj = { 'search': searchInput }
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        let response = await api.getListData(DIR + '/' + contractAlvId + '/works', getters.getCurrentPage, paramsString)

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPublishingContractsWorks', [])   
        } else {
            if(searchInput !== null && searchInput !== '' && response.list.length !== 0) {
                commit('setShowWorksDeleteResultListButton', true)
                commit('setWorksSearchId', response.searchId)
            } else {
                commit('setShowWorksDeleteResultListButton', false)
                commit('setWorksSearchId', null)
            }
            commit('setPublishingContractsWorks', response.list) 
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords, response.numberOfPages)
        commit('setIsLoading', false)
    },
    async setWorksTypeAction({ getters, dispatch, commit }, type){
        let alvId = getters.getPublishingContractsDetailsAlvId
        let metaData = {
            "type": type
        }
        let queryParams = { "action": 'setWorksTypeAction'}

        const response = await api.triggerAction(DIR + "/" + alvId + "/works", metaData, queryParams)
        
        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_CAPTION_PROCESSING_SUCCESS')
            })
        }
        dispatch('fetchPublishingContractsWorks')
    },
    async fetchPublishingContractConditions({ getters, commit}) {
        commit('setIsLoading', false)
        let conditions = await getters.getPublishingContractsDetails.conditions
        if(conditions === undefined) return null
        else {
            if(conditions.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPublishingContractConditions', conditions)
        }
    },
    async fetchPublishingContractConditionsSplits({ getters, commit}) {
        commit('setIsLoading', false)
        let conditions = await getters.getPublishingContractsDetails.conditions
        if(conditions === undefined) return null
        else {
            if(conditions.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPublishingContractConditions', conditions)
        }
    },
    async searchSplitsForContract({ getters }) {
        let params = `publishingContractId=${getters.getPublishingContractsDetailsAlvId}`
        let response = await api.getFilteredResults("publishing/splits", params)
        return response
    },
    async searchConditionsForContract({ getters }) {
        let params = `publishingContractId=${getters.getPublishingContractsDetailsAlvId}`
        let response = await api.getFilteredResults("publishing/conditions", params)
        return response
    },
    async addSplitsToContract({ getters, commit, dispatch }) {
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let context = "addSplits"
        let metaData = {
            "alvIds": contractAlvId
        }

        let response = await api.addMultipleRowsToDataTable(DIR + '/' + contractAlvId, metaData, context) 
        
        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL')
            })
            dispatch('savePublishingContractsForm')
        } else {  
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL')
            })            
        }   
    },
    async addConditionsToContract({ getters, commit, dispatch }) {
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let context = "addConditions"
        let metaData = {
            "alvIds": contractAlvId
        }

        let response = await api.addMultipleRowsToDataTable(DIR + '/' + contractAlvId, metaData, context) 
        
        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL')
            })
            dispatch('savePublishingContractsForm')
        } else {  
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL')
            })            
        }   
    },
    // Conditions RECIPIENT
    async fetchAutocompletePublishingContractConditionsRecipientId({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        
        commit('setPublishingContractConditionsRecipientIdOptions', response.list)
    },

    // Conditions Splits RECIPIENT
    async fetchAutocompletePublishingContractConditionsSplitsRecipientId({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setPublishingContractConditionsSplitsRecipientIdOptions', response.list)
    },

    // Conditions Splits SHARES TO CONSIDER (for author-specific weighting)
    async fetchAutocompletePublishingContractConditionsSplitsSharesToConsider({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setPublishingContractConditionsSplitsSharesToConsiderOptions', response.list)
    },

    // DELETE Conditions
    deleteSelectedPublishingContractConditions({ getters, commit }) {
        let id = getters.getSelectedPublishingContractConditions[0]
        let index = state.publishingContractConditions.findIndex(cond => cond.id == id)

        let startConditionAmount = getters.getPublishingContractConditions.length
        Vue.delete(state.publishingContractConditions, index)
        let newConditionAmount = getters.getPublishingContractConditions.length
        commit("setSelectedPublishingContractConditions", [])

        if(startConditionAmount > newConditionAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        }

        commit('setSelectedPublishingContractConditions', [])
        if(newConditionAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },

    // DELETE Conditions Splits
    deleteSelectedPublishingContractConditionsSplits({ getters, commit }) {
        let split = getters.getSelectedPublishingContractConditionsSplits;

        var mappedValues = getters.getPublishingContractsDetails.conditions.map((el) => {
            el.splits = el.splits.filter(elem => elem.id != split.id)
            return el
        })

        var toUpdate = getters.getPublishingContractsDetails
        toUpdate.conditions = mappedValues
        commit("setPublishingContractsDetails", toUpdate);
        commit("setSelectedPublishingContractConditionsSplits", null)

        commit('setSnackbar', { 
            type: 'success', 
            msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
            timeout: -1
        })
    },

    // SEARCH + ADD works
    async searchWorksForContract({ getters }) {
        let params = "search=" + getters.getWorksForContractSearch + '&publishingContractId=' + getters.getPublishingContractsDetailsAlvId 
        let response = await api.getFilteredResults("publishing/works", params)
        return response
    },
    async addWorksToContract({ getters, commit, dispatch }, params){
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let selectedWorks = getters.getSelectedWorksForContract
        // let uniqueId = getters.getPublishingContractsUniqueId
        let context = "addWorks"
        let response
        
        if(params.searchId !== null) {
            let metaData = {
                "searchId": params.searchId
            }
            response = await api.addMultipleRowsToDataTable(DIR + '/' + contractAlvId, metaData, context) 
        } else {
            let metaData = {
                "alvIds": selectedWorks
            }
            response = await api.addMultipleRowsToDataTable(DIR + '/' + contractAlvId, metaData, context) 
        }
        
        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL')
            })
            // dispatch('fetchPublishingContractsWorks')
            dispatch('savePublishingContractsForm')


        } else {  
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL')
            })            
        }   
        
        // return response
    },
    
    // DELETE work
    async deleteSelectedContractPublishingWork({ getters, commit, dispatch }){
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let selectedWork = getters.getSelectedContractPublishingWork

        let response = await api.deleteEntries(DIR + '/' + contractAlvId + '?deleteWork', [selectedWork])

        if(response.error === -1) {
            // dispatch('fetchPublishingContractsWorks')
            dispatch('savePublishingContractsForm')
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL')
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedContractPublishingWork', [])
    },
    // DELETE all works from Contract
    async deleteAllWorksFromPublishingContract({ getters, commit, dispatch }) {
        commit('setIsLoading', true)
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let selectedWorks = {}
        let allAlvIds = []

        if(getters.getTotalListed <= 100) {
            getters.getPublishingContractsWorks.forEach(work => {
                allAlvIds.push(work.alvId)
            })
            selectedWorks = {
                "alvIds" : allAlvIds
            }
        } else {
            selectedWorks = {
                "searchId" : getters.getWorksSearchId
            }
        }

        let response = await api.deleteEntries(DIR + '/' + contractAlvId + '?deleteWork', selectedWorks)
        commit('setIsLoading', false)

        if(response.error === -1) {
            dispatch('savePublishingContractsForm')
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL')
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setWorksSearchId', null)
    },

    // SUB-CATALOGUES
    async fetchPublishingContractsSubCatalogues({ getters, commit}) {
        commit('setIsLoading', true)

        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let response = await api.getListData(DIR + '/' + contractAlvId + '/subcatalogues', getters.getCurrentPage)

        if(response === undefined || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPublishingContractsSubCatalogues', [])   
        } else {
            commit('setPublishingContractsSubCatalogues', response.list)   
        }

        // this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords, response.numberOfPages)
        commit('setIsLoading', false)
    },

    // Licensor Autocomplete for Sub-Catalogues
    async fetchAutocompletePublishingContractsSubCataloguesLicensor({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setPublishingContractsSubCataloguesLicensorOptions', response.list)
    },

    // Edit/Add Sub-Catalogues
    async savePublishingContractsSubCatalogues({ getters, commit, dispatch}) {        
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let details = getters.getPublishingContractsSubCataloguesEditingDialogDetails

        let response = await api.addRowToDataTable(DIR + '/' + contractAlvId, details, "saveSubcatalogue")

        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL'),
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL'),
            })
        }
        
        dispatch('fetchPublishingContractsSubCatalogues')
    },
    // DELETE Sub-Catalogue
    async deleteSelectedPublishingContractsSubCatalogues({ getters, commit, dispatch }) {
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let selectedCatalogue = getters.getSelectedPublishingContractsSubCatalogues

        let response = await api.deleteEntries(DIR + '/' + contractAlvId, { "alvIds": [selectedCatalogue] })

        if(response.error === -1) {
            dispatch('fetchPublishingContractsSubCatalogues')
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL')
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedPublishingContractsSubCatalogues', [])
    },
    // FETCH WORKS for specific subcatalogue
    async fetchPublishingContractsSubCataloguesWorks({ commit, getters }, subcatalogueAlvId) {
        commit('setIsLoading', true)
        
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        
        // search filter
        let searchInput = getters.getPublishingContractsSubCataloguesWorksSearch
        let filterObj = { 'search' : searchInput }
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        let response = await api.getListData(DIR + '/' + contractAlvId + '/subcatalogues/' + subcatalogueAlvId + '/works', getters.getCurrentPage, paramsString)

        if(response === undefined || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPublishingContractsSubCataloguesWorks', [])   
        } else {
            if(searchInput !== null && searchInput !== '' && response.list.length !== 0) {
                commit('setShowSubCataloguesWorksDeleteResultListButton', true)
                commit('setSubCataloguesWorksSearchId', response.searchId)
            } else {
                commit('setShowSubCataloguesWorksDeleteResultListButton', false)
                commit('setSubCataloguesWorksSearchId', null)
            }
            commit('setPublishingContractsSubCataloguesWorks', response.list)   
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords, response.numberOfPages)
        commit('setIsLoading', false)
    },
    // SEARCH + ADD works to subcatalogue
    async searchWorksForSubCatalogues({ getters }) {
        let params = "search=" + getters.getWorksForSubCataloguesSearch + '&publishingSubCatalogueId=' + getters.getSelectedPublishingContractsSubCatalogues 
        let response = await api.getFilteredResults("publishing/works", params)
        return response
    },
    async addWorksToSubCatalogue({ getters, commit, dispatch }, params){
        commit('setIsLoading', true)
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let subCatalogueAlvId = getters.getSelectedPublishingContractsSubCatalogues 
        let selectedWorks = getters.getSelectedWorksForSubCatalogues
        // let uniqueId = getters.getPublishingContractsUniqueId
        let context = "addWorks"
        let response
        let metaData = {}
        
        if(params.searchId !== null) {
            metaData = { "searchId": params.searchId }
        } else {
            metaData = { "alvIds": selectedWorks }
        }

        response = await api.addMultipleRowsToDataTable(DIR + '/' + contractAlvId + '/subcatalogues/' + subCatalogueAlvId, metaData, context) 
        
        commit('setIsLoading', false)
        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL')
            })
            dispatch('savePublishingContractsForm')
            dispatch('fetchPublishingContractsSubCataloguesWorks', subCatalogueAlvId)

        } else {  
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL')
            })            
        }   
    },
    // DELETE work from sub-catalogue
    async deleteSelectedWorksForSubCatalogues({ getters, commit, dispatch }){
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let subCatalogueAlvId = getters.getSelectedPublishingContractsSubCatalogues 
        let selectedWork = getters.getSelectedWorksForSubCatalogues

        let response = await api.deleteEntries(DIR + '/' + contractAlvId + '/subcatalogues/' + subCatalogueAlvId + '?deleteWork', [selectedWork])

        if(response.error === -1) {
            dispatch('savePublishingContractsForm')
            dispatch('fetchPublishingContractsSubCataloguesWorks', subCatalogueAlvId)
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL')
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedWorksForSubCatalogues', [])
    },
    // DELETE ALL works from subcatalogue (after search)
    async deleteAllWorksFromSubCatalogues({ getters, commit, dispatch }){
        commit('setIsLoading', true)
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let subCatalogueAlvId = getters.getSelectedPublishingContractsSubCatalogues 
        let selectedWorks = {}
        let allAlvIds = []

        if(getters.getTotalListed <= 100) {
            getters.getPublishingContractsSubCataloguesWorks.forEach(work => {
                allAlvIds.push(work.alvId)
            })
            selectedWorks = {
                "alvIds" : allAlvIds
            }
        } else {
            selectedWorks = {
                "searchId" : getters.getSubCataloguesWorksSearchId
            }
        }

        let response = await api.deleteEntries(DIR + '/' + contractAlvId + '/subcatalogues/' + subCatalogueAlvId + '?deleteWork', selectedWorks)
        commit('setIsLoading', false)

        if(response.error === -1) {
            dispatch('savePublishingContractsForm')
            dispatch('fetchPublishingContractsSubCataloguesWorks', subCatalogueAlvId)
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL')
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSubCataloguesWorksSearchId', null)
    },

    // COSTS PANEL
    async fetchPublishingContractsCosts({ getters, commit }) {
        commit('setIsLoading', true)
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let response = await api.getListData(DIR + '/' + contractAlvId + '/costs', getters.getPublishingContractsCostsCurrentPage)

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPublishingContractsCosts', [])   
        } else {
            commit('setPublishingContractsCosts', response.list)
            commit('setPublishingContractsCostsTotalRecords', response.totalRecords)
            commit('setPublishingContractsCostsTotalListed', response.filteredRecords)
            commit('setPublishingContractsCostsCurrentPage', response.currentPage)
            commit('setPublishingContractsCostsNumberOfPages', response.numberOfPages)
        }       
        commit('setIsLoading', false)
    },
    async deleteSelectedPublishingContractsCosts({ getters, commit, dispatch}) {
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let selectedCosts = getters.getSelectedPublishingContractsCosts

        let response = await api.deleteEntries(DIR + '/' + contractAlvId + '?deleteCosts', { alvIds: [selectedCosts.alvId] })

        if(response.error === -1) {
            dispatch('fetchPublishingContractsCosts')
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL'),
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }
        commit('setSelectedPublishingContractsCosts', [])
    },
    async fetchAutocompletePublishingContractsCostsRecipient({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setPublishingContractsCostsRecipientOptions', response.list)
    },
    async fetchAssignToWorkDropdown({ commit, getters }) {
        let alvId = getters.getPublishingContractsDetailsAlvId
        let works = await api.getListData(DIR + '/' + alvId + '/works', 1)
        if(works && works.list) {
            let options = works.list.map(work => {
                return {
                    ...work,
                    text: work.title + ' (' + work.alvId + ')'
                }
            })
            commit('setPublishingContractsCostsAssignToWorkOptions', options)
        } else {
            commit('setPublishingContractsCostsAssignToWorkOptions', [])
        }
    },
    async addPublishingContractsCosts({ getters, commit, dispatch }) {
        let contractAlvId = getters.getPublishingContractsDetailsAlvId
        let costsDetails = getters.getPublishingContractsCostsEditingDialogDetails

        let response = await api.addRowToDataTable(DIR + '/' + contractAlvId, costsDetails, "addCosts")

        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL'),
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL'),
            })
        }

        dispatch('fetchPublishingContractsCosts')
    },

    // ADVANCE PANEL
    async fetchPublishingContractsAgreementNumbers({ getters, commit }) {
        let rows = getters.getPublishingContractsDetails.agreementNumbers
        if (rows === undefined || rows === null) {
            rows = []
        }
        commit('setPublishingContractsAgreementNumbers', rows)
    },
    async deleteSelectedPublishingContractsAgreementNumbers({ getters, commit }) {
        let selected = getters.getSelectedPublishingContractsAgreementNumbers
        let rows = getters.getPublishingContractsAgreementNumbers
        let index = rows.findIndex(row => JSON.stringify(row) === JSON.stringify(selected) || row.id === selected.id)

        let startAmount = rows.length
        if (index > -1) {
            Vue.delete(rows, index)
        }
        let newAmount = rows.length

        if (startAmount > newAmount) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
            })
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedPublishingContractsAgreementNumbers', [])
        if (newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },
    async fetchPublishingContractsAdvance({ getters, commit, dispatch }) {
        let advance = getters.getPublishingContractsDetails.advance
        commit('setIsLoading', false)

        if(advance === undefined) {
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            advance = []
        }
        
        commit('setPublishingContractsAdvance', advance)
        dispatch('calculatePublishingContractsAdvanceBalance')
    },
    async deleteSelectedPublishingContractsAdvance({ getters, commit, dispatch}) {
        let selectedAdvance = getters.getSelectedPublishingContractsAdvance
        let advance = getters.getPublishingContractsAdvance
        let index = advance.findIndex(text => text.id === selectedAdvance.id)

        let startAmount = advance.length
        Vue.delete(advance, index)
        let newAmount = advance.length

        await dispatch("calculatePublishingContractsAdvanceBalance")
        let newAdvance = getters.getPublishingContractsAdvance

        if(newAdvance.length === 0) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
            })
            commit('setSelectedPublishingContractsAdvance', [])
            if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        } 
        else {
            if(newAdvance[0].balance > 0) {
                commit('setSnackbar', { 
                    type: 'error', 
                    msg: i18n.t("lang_CONTRACTS_LABEL_ADVANCE_PANEL_SNACKBAR_BALANCE_TOO_HIGH"), 
                })
                advance.splice(index, 0, selectedAdvance)
                commit('setPublishingContractsAdvance', advance)
            } else {
                if(startAmount > newAmount) {
                    commit('setSnackbar', { 
                        type: 'success', 
                        msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                    })
                } else {
                    commit('setSnackbar', { 
                        type: 'error', 
                        msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'), 
                    })
                }
            }

            commit('setSelectedPublishingContractsAdvance', [])
            if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        }
    },
    async calculatePublishingContractsAdvanceBalance({ getters, commit }) {
        let advance = JSON.parse(JSON.stringify(getters.getPublishingContractsAdvance))
        advance.reverse()
        advance.reduce(function(prevValue, item){
            item.balance = prevValue + item.amount
            return item.balance
        }, 0)
        advance.reverse()
        commit('setPublishingContractsAdvance', advance)
    },

// SAVE
    async savePublishingContractsForm({ commit, getters, dispatch }){
        let alvId = getters.getPublishingContractsDetailsAlvId
        // let uniqueId = getters.getPublishingContractsUniqueId
        if(getters.getPublishingContractSplits.length !== 0) getters.getPublishingContractsDetails.splits = getters.getPublishingContractSplits
        if(getters.getPublishingContractsWorks.length !== 0) getters.getPublishingContractsDetails.works = getters.getPublishingContractsWorks
        getters.getPublishingContractsDetails.advance = getters.getPublishingContractsAdvance
        getters.getPublishingContractsDetails.agreementNumbers = getters.getPublishingContractsAgreementNumbers
        let metaData = _.cloneDeep(getters.getPublishingContractsDetails)
        let isNew = router.currentRoute.params.alvId == "new"
        if(metaData.initialBalance === '') metaData.initialBalance = null
        metaData.initialBalance = this._vm.$alvPlugin.normalizeDecimalFormat(metaData.initialBalance)

        // Clean up the splits array from attributes we only needed in the frontend.
        if (metaData.conditions && metaData.conditions.length > 0) {
            metaData.conditions.forEach(condition => {
                if (condition.splits && condition.splits.length > 0) {
                    condition.splits.forEach(split => {
                        if (split.sharesToConsider && typeof split.sharesToConsider === 'object' && split.sharesToConsider.alvId) {
                            split.sharesToConsider = split.sharesToConsider.alvId;
                        }
                    });
                }
            });
        }
        
        delete metaData.works
        // let response = await api.saveEditForm(DIR, alvId, metaData, isNew, uniqueId)
        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        if(response === undefined || response.length === 0 || response.error === 1) { 
            response = []
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERAL_CAPTION_ERROR'), // TODO: better message for user
            })
        } else {
            // let alvId = response.response.alvId
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_CONTRACTS_PUBLISHING_SNACKBAR_CONTRACT_SAVED')
            })
            // redirect for url now with ALVID
            if(isNew) {
                router.push( { name: 'PublishingContractsEdit', params: { alvId:  response.response.alvId } })
            }
            // refresh data
            await dispatch('fetchPublishingContractsDetails',  response.response.alvId)
            await dispatch('fetchPublishingContractSplits')
            await dispatch('fetchPublishingContractConditions')
            await dispatch('fetchPublishingContractsWorks')
        }
    },

    async fetchAzPersonByAlvId({ commit, getters }, alvId) {
        const cachedPerson = getters.getAzPersonsCache[alvId];
        if (cachedPerson) {
            return cachedPerson;
        }

        const response = await api.getDetailsById('az/persons', alvId);
        if (response && response.error !== 1) {
            commit('setAzPersonInCache', { alvId, azObject: response });
            return response;
        }
        return null;
    },

// ACTIONS Switch
    async doPublishingContractsAction({ commit, getters, dispatch }) {
        let selectedContracts = getters.getSelectedPublishingContracts
            switch(getters.getSelectedPublishingContractsAction) {
                case 'delete':
                    if(selectedContracts.length > 0){
                        commit('setShowDeletionDialog', true)
                    }else{
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'replaceTags':
                    if(selectedContracts.length > 0){
                        commit('setShowManageTagsDialog', true)
                    }else{
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'copyWithWorks': case 'copyWithoutWorks':
                    if(selectedContracts.length > 0){
                        if(selectedContracts.length === 1) {
                            dispatch('copyPublishingContract')
                        } else {
                            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                            commit('setShowSelectionRequiredDialog', true)
                        }
                    }else{
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'copyConditions':
                    if(selectedContracts.length === 1) {
                        let result = await dispatch('checkContractConditions')
                        if (!result) {
                            commit('setSelectionRequiredText', 'lang_CONTRACTS_PUBLISHING_ERROR_NO_CONDITIONS') 
                            commit('setShowSelectionRequiredDialog', true)
                        } else {
                            commit('setShowSearchDialog', true)
                        }
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'move':
                    if(selectedContracts.length > 0) {
                        commit('setShowMoveContractsDialog',true)
                    }else{
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true) 
                    } 
                    break
                case 'export':
                        if(selectedContracts.length === 0){
                            //Export All
                            let r = await dispatch('runConfirmationDialog')
                            if(r){
                                commit('setContractsPublishingExportAll', true)
                                commit('setShowContractsPublishingExportDialog',true)
                            }
                        }else{
                            commit('setContractsPublishingExportAll', false)
                            commit('setShowContractsPublishingExportDialog',true)
                        }
                        break
                case 'groupContracts':
                    if(selectedContracts.length < 2){
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_MORE_THAN_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }else{
                        commit('setPublishingContractsGroupDialogName', '')
                        dispatch('fetchExistingGroupName')
                        commit('setShowPublishingContractsGroupDialog', true)
                    }
                    break
                case 'ungroupContracts':
                    if(selectedContracts.length === 0){
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }else{
                        dispatch('ungroupPublishingContracts')
                    }
                    break
            }
    },

    // DELETE Action
    async deleteSelectedPublishingContracts({ getters, commit, dispatch }) {
        const response = await api.deleteEntries(DIR, getters.getSelectedPublishingContracts)

        if(response.error === -1) {        
            for(let i = 0; i < getters.getSelectedPublishingContracts.length; i++) {
                let index = getters.getPublishingContracts.findIndex(contract => contract.alvId == getters.getSelectedPublishingContracts[i])
                Vue.delete(getters.getSelectedPublishingContracts, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })

            commit('setSelectedPublishingContracts', [])
            commit('setSelectedPublishingContractsAction', [])
            dispatch('fetchPublishingContracts')
        }
    },
        //ACtion : MOVE
        async moveSelectedPublishingContracts({ getters, commit, dispatch  }) {

            let metaData = { "alvIds" : getters.getSelectedPublishingContracts,
            
                             "company" : getters.getPublishingContractsDetailsSelectedCompany }
            let queryParams = { "action": 'move'}
            const response = await api.triggerAction(DIR,metaData,queryParams)
    
    
            if(response.error === -1) {
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_MOVED')
                })
            }
            
            commit('setSelectedPublishingContracts', [])
            commit("setIsAllSelectedPublishingContracts",false)
            commit('setSelectedPublishingContractsAction', [])
            dispatch('fetchPublishingContracts')
        },

    // Action: COPY
    async copyPublishingContract({ getters, commit, dispatch }) {
        let selectedActionValue = getters.getSelectedPublishingContractsAction
        let queryParams = { "action": selectedActionValue }
        let metaData = { "alvIds" : getters.getSelectedPublishingContracts }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_COPY_SUCCESSFULL')
            })
            dispatch('fetchPublishingContracts')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // GROUPED CONTRACTS PANEL
    async fetchPublishingContractsGroupedContracts({ commit, getters }) {
        let groupedContractsFromDB = await getters.getPublishingContractsDetails.groupedContracts

        if(groupedContractsFromDB === undefined) return null
        else {
            commit('setPublishingContractsGroupedContracts', groupedContractsFromDB)
        }
    },

    async fetchExistingGroupName({ getters, commit }) {
        let selected = getters.getSelectedPublishingContracts
        if(selected.length > 0) {
            let response = await api.getDetailsById(DIR, selected[0])
            if(response && response.groupedContracts && response.groupName) {
                commit('setPublishingContractsGroupDialogName', response.groupName)
            }
        }
    },

    async groupPublishingContracts({ getters, commit, dispatch }){
        let selected = getters.getSelectedPublishingContracts

        let queryParams = { "action": "groupContracts" }
        let metaData = { "alvIds" : selected, "groupName": getters.getPublishingContractsGroupDialogName }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_CONTRACTS_PUBLISHING_SNACKBAR_CONTRACT_SAVED')
            })
            dispatch('fetchPublishingContracts')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },
    async ungroupPublishingContracts({ getters, commit, dispatch }){
        let selected = getters.getSelectedPublishingContracts

        let queryParams = { "action": "ungroupContracts" }
        let metaData = { "alvIds" : selected }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_CONTRACTS_PUBLISHING_SNACKBAR_CONTRACT_SAVED')
            })
            dispatch('fetchPublishingContracts')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // Action: Copy conditions to contracts
    // Search for contracts
    async searchCopyConditionsForPublishingContracts({ getters, commit, dispatch }) {
        // check for set filters
        let filterObj = {
            search : getters.getCopyConditionsForPublishingContractsSearch,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)
        let response = await api.getListData(DIR, "1", paramsString)

        commit('setIsLoading', false)
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            return []
        } else {
            return response.list
        }
    },

    async checkContractConditions({ getters, commit, dispatch }) {
        let selectedContractAlvId = getters.getSelectedPublishingContracts[0]
        await dispatch('fetchPublishingContractsDetails', selectedContractAlvId)

        let contractDetails = getters.getPublishingContractsDetails
        if (contractDetails.conditions != undefined && contractDetails.conditions != null && contractDetails.conditions.length > 0) {
            return true
        }
        return false
    },

    async addCopyConditionsToPublishingContracts({getters, commit, dispatch }) {
        commit('setCopyConditionsForPublishingContractsCsvPath', null)
        let selectedContractAlvId = getters.getSelectedPublishingContracts[0]
        let endpoint = `${DIR}/${selectedContractAlvId}`
        let bodyData = {
            alvIds: getters.getSelectedCopyConditionsForPublishingContracts,
            tag: getters.getCopyConditionsForPublishingContractsTags,
            adaptRecipient: getters.getCopyConditionsForPublishingContractsAdaptRecipient ? 'yes' : 'no'
        }
        let queryParams = {copyConditions: ""}

        let response = await api.triggerAction(endpoint, bodyData, queryParams)  
                
        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERAL_SNACKBAR_ADDED_SUCCESSFULLY')
            })
            commit('setCopyConditionsForPublishingContractsCsvPath', response.response.path)
        }
    },
    // ACTION Export (type - mappings)
      async exportContractsPublishingMapping({ commit, getters }) {
        commit('setIsLoading', true)
        let queryParams = {
          action: "export",
          type: "mappings",
          mappingId: getters.getContractsPublishingExportDetailsMappingId,
        };
        // Support both select contract by checkbox and whole search result
        let metaData = { alvIds: getters.getSelectedPublishingContracts, exportAll: getters.getContractsPublishingExportAll ? 1 : 0 };
    
        let response =  await api.triggerAction(DIR, metaData, queryParams);
        if (response.error === -1) {
          if (response.response.path !== null) {
            api.getFileFromALV(response.response.path);
            commit("setSnackbar", {
              type: "success",
              msg: i18n.t("lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
            });
          }
        } else {
          let errorMsg = response.response.errorMsg;
          if (errorMsg !== undefined) {
            commit("setSnackbar", {
              type: "error",
              msg: this._vm.$alvPlugin.isLangConst(errorMsg)
                ? i18n.t(errorMsg)
                : errorMsg,
            });
          }
        }
        commit("setIsLoading", false);
      },
}

export default {
    state, getters, actions, mutations
}